/**
 * Drafting Settings dialog state (Faz 11.13 — DSETTINGS/OPTIONS parity).
 *
 * The dialog's visibility + active tab live here; the status-bar pill
 * right-clicks and the DSETTINGS command jump straight to the relevant
 * tab. Transient — nothing persists.
 */

import { create } from 'zustand';

export type DraftingSettingsTab =
    | 'snapGrid'
    | 'polarTracking'
    | 'objectSnap'
    | 'dynamicInput'
    | 'quickProperties';

interface DraftingSettingsState {
    open: boolean;
    tab: DraftingSettingsTab;
    /** Open the dialog at a specific tab (pill right-click jump point). */
    openAt: (tab: DraftingSettingsTab) => void;
    close: () => void;
}

export const TAB_INDEX: Record<DraftingSettingsTab, number> = {
    snapGrid: 0,
    polarTracking: 1,
    objectSnap: 2,
    dynamicInput: 3,
    quickProperties: 4,
};

export const useDraftingSettingsStore = create<DraftingSettingsState>((set) => ({
    open: false,
    tab: 'snapGrid',
    openAt: (tab) => set({ open: true, tab }),
    close: () => set({ open: false }),
}));
